import { StyledTagType } from 'ui-toolkit';

export enum eTaxCertificationRequestStatus {
  new = 'NEW',
  inProgress = 'IN_PROGRESS',
  cancelled = 'CANCELLED',
  sent = 'SENT',
  accepted = 'ACCEPTED',
}

export const prettyVendorStatus: Record<eTaxCertificationRequestStatus, string> = {
  [eTaxCertificationRequestStatus.new]: 'New',
  [eTaxCertificationRequestStatus.inProgress]: 'In Progress',
  [eTaxCertificationRequestStatus.cancelled]: 'Cancelled',
  [eTaxCertificationRequestStatus.sent]: 'Sent',
  [eTaxCertificationRequestStatus.accepted]: 'Accepted',
};

export const vendorStatusTagColor: Record<eTaxCertificationRequestStatus, StyledTagType> = {
  [eTaxCertificationRequestStatus.new]: 'green',
  [eTaxCertificationRequestStatus.inProgress]: 'yellow',
  [eTaxCertificationRequestStatus.cancelled]: 'gray',
  [eTaxCertificationRequestStatus.sent]: 'blue',
  [eTaxCertificationRequestStatus.accepted]: 'error',
};
export const activeStatuses = [
  eTaxCertificationRequestStatus.new,
  eTaxCertificationRequestStatus.inProgress,
  eTaxCertificationRequestStatus.sent,
];

export const allVendorStatuses = Object.values(eTaxCertificationRequestStatus);
export const vendorTaxReqInitialStatuses = [
  eTaxCertificationRequestStatus.new,
  eTaxCertificationRequestStatus.inProgress,
  eTaxCertificationRequestStatus.cancelled,
  eTaxCertificationRequestStatus.sent,
];
